import React from "react";
import { cn, formControlClass } from "./formStyles";

const TextInput = React.forwardRef(function TextInput(
  { className = "", invalid = false, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      className={cn(
        formControlClass,
        invalid && "border-red-500 focus:ring-red-500",
        className
      )}
      {...props}
    />
  );
});

export default TextInput;
